import { TableSkeleton } from '../../../components/table-skeleton';
import { times } from 'lodash';
import { ISkeletonListLoaderProps } from './skeleton-list-loader.interface';

export const SkeletonListLoader = ({ items = 3 }: ISkeletonListLoaderProps) => {
  const loaders = times(items, index => <TableSkeleton key={index} />);
  return <div className='skeleton-list-loader'>{loaders}</div>;
};
